import React, { useState, useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import colors from '../../theme/colors';


const EstilosToolTip = styled('div')({
    backgroundColor: colors.primary,
    color: 'white',
    maxWidth: 220,
    fontSize: 16,
    border: '1px solid ' + colors.textMain,
    padding: '1em'
});

export function ToolTipBoton({ children, titulo, body, className }) {
    return (
        <EstilosToolTip className={className}>
            <Stack gap={1}>
                <Typography variant='parrafoLigth' fontWeight={'bold'}>
                    {titulo}
                </Typography>
                <Typography variant='parrafoLigth'>{body}</Typography>
            </Stack>
        </EstilosToolTip>
    );
}